import React from 'react';
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Tooltip,
  IconButton,
} from '@mui/material';
import {
  LightMode as LightModeIcon,
  DarkMode as DarkModeIcon,
  Contrast as ContrastIcon,
} from '@mui/icons-material';
import { useRecoilState } from 'recoil';
import { themeState } from '../../Recoil/RecoilState';

const ThemeSwitcher = ({ variant = 'toggle' }) => {
  const [themeMode, setThemeMode] = useRecoilState(themeState);

  const handleThemeChange = (event, newMode) => {
    if (newMode !== null) {
      setThemeMode(newMode);
    }
  };

  const themeOptions = [
    {
      value: 'light',
      label: 'Light Mode',
      icon: <LightModeIcon />,
      description: 'Standard light theme for normal viewing',
    },
    {
      value: 'dark',
      label: 'Dark Mode',
      icon: <DarkModeIcon />,
      description: 'Dark theme for reduced eye strain',
    },
    {
      value: 'highContrast',
      label: 'High Contrast',
      icon: <ContrastIcon />,
      description: 'High contrast theme for visual accessibility',
    },
  ];

  if (variant === 'toggle') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Theme:
        </Typography>
        <ToggleButtonGroup
          value={themeMode}
          exclusive
          onChange={handleThemeChange}
          aria-label="theme selection"
          size="small"
        >
          {themeOptions.map((option) => (
            <Tooltip
              key={option.value}
              title={option.description}
              placement="top"
            >
              <ToggleButton
                value={option.value}
                aria-label={option.label}
                sx={{
                  minWidth: 'auto',
                  px: 1,
                  '&.Mui-selected': {
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    '&:hover': {
                      backgroundColor: 'primary.dark',
                    },
                  },
                }}
              >
                {option.icon}
              </ToggleButton>
            </Tooltip>
          ))}
        </ToggleButtonGroup>
      </Box>
    );
  }

  // Icon button variant for compact display
  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      {themeOptions.map((option) => (
        <Tooltip
          key={option.value}
          title={`${option.label}: ${option.description}`}
          placement="top"
        >
          <IconButton
            onClick={() => setThemeMode(option.value)}
            color={themeMode === option.value ? 'primary' : 'default'}
            aria-label={option.label}
            size="small"
            sx={{
              border: themeMode === option.value ? 2 : 1,
              borderColor: themeMode === option.value ? 'primary.main' : 'divider',
            }}
          >
            {option.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
};

export default ThemeSwitcher; 